import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { AnimatedCounter } from "../shared/AnimatedCounter";

export const StatsSection = () => {
  const { translations: t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const stats = [
    { number: 40, suffix: "+", label: t.stats.experience },
    { number: 3000, suffix: "+", label: t.stats.clients },
    { number: 95, suffix: "%", label: t.stats.success },
  ];

  return (
    <section className="py-16 md:py-20 bg-[#FAF7F2]" ref={ref} data-testid="stats-section">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-3 gap-8 text-center">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: i * 0.2 }}
            >
              <div className="font-['Heebo'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#C4956A]">
                <AnimatedCounter end={stat.number} suffix={stat.suffix} />
              </div>
              <div className="text-[#2C2C2C]/70 mt-2">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
